module.exports = __webpack_public_path__ + "img/TRANSPORTATION.16e3d3a9.jpg";